import { ScheduleLayer} from './schedule.layer';

export class Schedule {
    cmpnNo: number;
    schdNo: number;
    dispNm: string;
    tmznCd: string;
    statCd: string;
    stDfwCd: string;
    regrNo: number;
    regDt: string;
    mdfrNo: number;
    mdfDt: string;
    dtlDesc: string;
    teamNo: number;
    tmznOfsVal: string;
    schdLayerList = [];
    constructor(
        values: {
            cmpnNo?: number,
            schdNo?: number,
            dispNm?: string,
            tmznCd?: string,
            statCd?: string,
            stDfwCd?: string,
            regrNo?: number,
            regDt?: string,
            mdfrNo?: number,
            mdfDt?: string,
            dtlDesc?: string,
            teamNo?: number,
            tmznOfsVal?: string,
            schdLayer?: object} = {}) {
        this.cmpnNo = values.cmpnNo || null;
        this.schdNo = values.schdNo || null;
        this.dispNm = values.dispNm || null;
        this.tmznCd = values.tmznCd || null;
        this.statCd = values.statCd || null;
        this.stDfwCd = values.stDfwCd || null;
        this.regrNo = values.regrNo || null;
        this.regDt = values.regDt || null;
        this.mdfrNo = values.mdfrNo || null;
        this.mdfDt = values.mdfDt || null;
        this.dtlDesc = values.dtlDesc || null;
        this.teamNo = values.teamNo || null;
        this.tmznOfsVal = values.tmznOfsVal || null;
        this.schdLayerList.push(new ScheduleLayer());
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/src/schedule/shcedule.ts